import { getOauth2MiddlewareRegistered } from '../../../middleware/globalConfiguration';
/**
 * oauth2 REST API facade decorator. An ugly way to globally disable oauth2 facade actions when using oauth2 middleware to prevent breaking changes
 *
 * @documented
 * @category facadeDecorator
 *
 * @returns function
 * @param oauth2refreshTokenFacade
 */ export const withDisabledRefreshTokenFacade = (oauth2refreshTokenFacade)=>(wrapped)=>(args = {})=>async (dispatch)=>{
                if (getOauth2MiddlewareRegistered()) {
                    return dispatch(wrapped(args));
                } else {
                    return dispatch(oauth2refreshTokenFacade(wrapped)(args));
                }
            };
